<template>
    <input
        type="number"
        step=".01"
        min="0"
        class="form-control"
        ref="input"
        @blur="updateFormatting($event.target.value)"
        @input="updateValue($event.target.value)"
    />
</template>

<script>
export default {
    props: {
        value: [String, Number, null],
        pattern: {
            type: RegExp,
        }
    },
    mounted: function() {
        this.setInitialValue(this.value);
    },
    watch: {
        value: function(value) {
            this.setFloatValue(value);
        }
    },
    methods: {
        setInitialValue: function(value) {
            if (value) {
                this.setFloatValue(value);
                this.updateFormatting();
            } 
        },
        setFloatValue: function(value) {
            if (value != null) {
                this.updateValue(value / 100);
            }
        },
        updateFormatting: function(value) {
            if (this.$refs.input && this.$refs.input.value) {
                let numeric = parseFloat(this.$refs.input.value)

                if (numeric) {
                    this.$refs.input.value = numeric.toFixed(2);
                }
            }
        },
        updateValue: function(value) { 
            let numericaValue = null;

            if (typeof value === 'number') {
                numericaValue = value;
            }
            else if (typeof value === 'string') {
                numericaValue = value.replace(/[^0-9.-]/g, '');
                
                if (numericaValue) {
                    numericaValue = parseFloat(numericaValue);
                };
            }
            
            this.$refs.input.value = value;
            
            if (numericaValue && numericaValue != this.value) {
                this.$emit('input', Math.round(numericaValue * 100));
            }
            else {
                this.$emit('input', value == null ? null : value);
            }
        }
    }
}
</script>